<template>
  <v-container>
    <v-card class="elevation-1 pa-4 login-card">
      <v-card-title>
        <div class="layout column align-center">
          <h2 class="flex my-2 primary--text">
            {{ $route.meta.title }}
          </h2>
        </div>
      </v-card-title>
      <v-card-text>
        <v-card>
          <v-tabs
            v-model="tp_inscricao"
            color="white"
            centered
            icons-and-text
          >
            <v-tabs-slider />
            <v-tab href="#conselho">
              Conselho
              <v-icon>group</v-icon>
            </v-tab>
            <v-tab href="#organizacao">
              Organização ou Entidade
              <v-icon>color_lens</v-icon>
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tp_inscricao">
            <v-tab-item value="conselho">
              <habilitacao-conselho-lista-habilitados/>
            </v-tab-item>
            <v-tab-item value="organizacao">
              <habilitacao-organizacao-lista-habilitados/>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import HabilitacaoConselhoListaHabilitados from '../../../conselho/views/HabilitacaoConselhoListaHabilitados';
import HabilitacaoOrganizacaoListaHabilitados from '../../../organizacao/views/HabilitacaoOrganizacaoListaHabilitados';

export default {
  name: 'ListaParcialHabilitacao',
  components: { 
    HabilitacaoConselhoListaHabilitados,
    HabilitacaoOrganizacaoListaHabilitados,
  },
  data() {
    return {
      tp_inscricao: null,
      pesquisar: '',
      tipoModal: '',
      mostrarModal: false,
    };
  },
  computed: {
    ...mapGetters({
    }),
  },
  methods: {
    ...mapActions({
    }),
  },
  mounted() {
    this.obterConselhosParcialmenteHabilitados()
  },
};
</script>
